import React, { Fragment } from 'react';

import { Chip, List } from '@mui/material';
import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { TranslationKey } from 'providers/i18n/types';
import { DEFAULT_TIMEZONE } from 'shared/mui/DatePicker/config/defaultValues';
import { Divider } from 'shared/mui/Divider/Divider';

import { Shortcuts } from './constants/shortcuts';
import { ListItemStyled } from './DatePickerShortcuts.styled';

export type Shortcut = {
  alias: string;
  label: TranslationKey;
  getValue: () => [number | null, number | null];
};

export type ShortcutsListProps = {
  shortcuts: Shortcuts;
  onClick?: (value: [number | null, number | null]) => void;
  timezone?: string;
};

export const DatePickerShortcuts: React.FC<ShortcutsListProps> = ({
  onClick,
  shortcuts,
  timezone = DEFAULT_TIMEZONE,
}) => {
  const translate = useTypedTranslate();

  return (
    <List>
      {shortcuts(timezone).map((shortcutSection, index) => (
        <Fragment key={index}>
          {index !== 0 && <Divider sx={{ marginY: '8px' }} />}

          {shortcutSection.map((shortcut) => (
            <ListItemStyled key={shortcut.label}>
              <Chip
                key={shortcut.label}
                label={translate(shortcut.label)}
                onClick={() => {
                  if (!onClick) {
                    return;
                  }
                  onClick(shortcut.getValue());
                }}
              />
            </ListItemStyled>
          ))}
        </Fragment>
      ))}
    </List>
  );
};
